import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-charcoal" data-id="element-151" data-mp="1o2vk0ww891a9">
      <div className="max-w-4xl mx-auto" data-id="element-152" data-mp="223epbw9b5t8q">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-ivory border border-sand-deep rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg" data-id="element-153" data-mp="2223kdt44mfg1">
          <div className="absolute top-0 left-0 w-full h-1 bg-orange" data-id="element-154" data-mp="1j52du3uxc79z" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-white text-orange border-2 border-orange/30 mb-8" data-id="element-155" data-mp="1j6die5w71j25">
            <ShieldCheckIcon size={48} aria-hidden="true" data-id="element-156" data-mp="qn7utc3xytkp" />
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-bold uppercase mb-6 text-charcoal" data-id="element-157" data-mp="lpg6es2i9pl9">
            Complete 7-day money-back guarantee
          </h2>
          <div className="space-y-6 text-lg text-charcoal max-w-2xl mx-auto" data-id="element-158" data-mp="oxfb4c17yttm">
            <p data-id="element-159" data-mp="tx1msh1eg20b">
              Open the complete 6-in-1 coaching system. Explore all the bonuses.
              Use the material in your most challenging session this week.
            </p>
            <p className="font-medium" data-id="element-160" data-mp="12pmsavg0sc77">
              If you find that the material isn&apos;t clear, practical or
              useful for your coaching needs, contact us within 7 days.
            </p>
            <p className="text-orange-deep font-bold text-xl" data-id="element-161" data-mp="b0jp7izvd7w5">
              We&apos;ll refund 100% of your money. No questions. No forms. No
              hassle.
            </p>
            <p className="text-sm text-warmgray" data-id="element-162" data-mp="k0ot3j5uto5k">
              Because if the material doesn&apos;t deliver the value we
              promised, we don&apos;t want your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}